import { getWindowObject } from './get-window-object';

/**
 * Safely check if the window exists and supports form data
 */
export const HAS_FORM_DATA = !!getWindowObject('FormData');
